import { Box } from "@material-ui/core";
import uniqueId from "lodash/uniqueId";
import React from "react";

import { Option } from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisChoiceRow } from "./DiagnosisChoiceRow";

type CheckboxListProps<T extends string> = {
  options: Option<T>[];
  selected: T[];
  single?: boolean;
  max?: number;
  onChange: (next: T[]) => void;
};
export function DiagnosisInvestmentStyleCheckboxList<T extends string>({
  options,
  selected,
  single,
  max,
  onChange,
}: CheckboxListProps<T>) {
  const [name] = React.useState(() => uniqueId("diagnosis-choice-"));
  const toggle = (value: T) => {
    if (single) {
      onChange([value]);
      return;
    }
    if (selected.includes(value)) {
      onChange(selected.filter((v) => v !== value));
      return;
    }
    if (max && selected.length >= max) return;
    onChange([...selected, value]);
  };
  return (
    <Box display="flex" flexDirection="column" style={{ gap: 8 }}>
      {options.map((option) => (
        <DiagnosisChoiceRow
          key={option.value}
          label={option.label}
          value={option.value}
          type={single ? "radio" : "checkbox"}
          name={name}
          checked={selected.includes(option.value)}
          disabled={!single && !selected.includes(option.value) && !!max && selected.length >= max}
          onChange={() => toggle(option.value)}
        />
      ))}
    </Box>
  );
}
